import Auth from '@Services/Auth';
import ProfileSettings from '@Services/ProfileSettings';
import Catalyst from '@Services/Catalyst';

import { profileSetIsLoadingReducerType, profileSetInputDataReducerType, profileSetAllSalutationsReducerType } from './ProfileConstants';

import { inputData as inputDataSelector, valueByFieldName as valueByFieldNameSelector } from './ProfileSelectors';

export function setIsLoading(isLoading) {
  return {
    type: profileSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setInputData(inputData) {
  return {
    type: profileSetInputDataReducerType,
    payload: { inputData },
  };
}

export function setAllSalutations(allSalutations) {
  return {
    type: profileSetAllSalutationsReducerType,
    payload: { allSalutations },
  };
}

export function resetInputData(fieldName) {
  return async (dispatch, getState) => {
    const user = ProfileSettings.get();
    const value = user.PROFILE[fieldName];
    const inputData = inputDataSelector(getState());
    dispatch(setInputData({ ...inputData, [fieldName]: value }));
  };
}

export function saveInputData(fieldName) {
  return async (dispatch, getState) => {
    dispatch(setIsLoading(true));

    const user = ProfileSettings.get();

    const value = valueByFieldNameSelector(fieldName)(getState());

    ProfileSettings.setModelValue(user, `PROFILE.${fieldName}`, value ?? '');

    return (
      ProfileSettings.update(user.PROFILE)
        .then(() => {
          if (fieldName === 'firstName' || fieldName === 'lastName') {
            const currentUser = Auth.getUser();
            currentUser.details[fieldName] = value ?? '';
            Auth.updateUser(currentUser);
          }
        })
        .finally(() => {
          dispatch(setIsLoading(false));
        })
        .catch(Logger.reject)
    );
  };
}

export const init = () =>
  async (dispatch) => {
    const user = ProfileSettings.get();
    const allSalutations = ProfileSettings.getSalutations();
    dispatch(
      setInputData({
        firstName: user.PROFILE.firstName,
        lastName: user.PROFILE.lastName,
        jobTitle: user.PROFILE.jobTitle,
        location: user.PROFILE.location,
        institution: user.PROFILE.institution,
        salutation: user.PROFILE.salutation,
      })
    );
    dispatch(setAllSalutations(allSalutations));
  };

export function trackAdobeAnalyticsError(fieldName, formErrors) {
  if (!formErrors) {
    return;
  }
  formErrors.forEach((error) =>
    Catalyst.trackError(
      {
        message: error,
        component: `Edit ${fieldName}`,
      },
      'fe-'
    )
  );
}
